import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <footer
                className={
                    'footer' +
                    (this.props.transparent !== undefined
                        ? ' footer-transparent'
                        : '')
                }
            >
                <div
                    className={
                        'container' +
                        (this.props.fluid !== undefined ? '-fluid' : '')
                    }
                >
                    <nav className="pull-left" />
                    <p className="copyright pull-right">
                        {`©${1900 + new Date().getYear()} Benito Santos`}
                    </p>
                </div>
            </footer>
        );
    }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx